import { render, staticRenderFns } from "./pages-wrapper.vue?vue&type=template&id=e1afd1c2&"
import script from "./pages-wrapper.vue?vue&type=script&lang=js&"
export * from "./pages-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./pages-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1afd1c2')) {
      api.createRecord('e1afd1c2', component.options)
    } else {
      api.reload('e1afd1c2', component.options)
    }
    module.hot.accept("./pages-wrapper.vue?vue&type=template&id=e1afd1c2&", function () {
      api.rerender('e1afd1c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/info-pages/pages-wrapper.vue"
export default component.exports